import styled from 'styled-components';
import { useCancelBookingPreApprovalMutation } from 'components/booking/mutationHooks';
import { Booking } from 'swagger/models';
import { useCloseModal } from 'components/remodal/v2/hooks';
import useLazySnackbar from 'components/banners/useLazySnackbar';
import Button from 'components/ui/Button/Button';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { mediaMSmMax } from '../../helpers/breakpoints';

type ModalProps = {
  booking: Booking;
  onSuccess?: () => void;
};

const CancelPreApprovalModal = ({ booking, onSuccess }: ModalProps) => {
  const closeModal = useCloseModal();
  const { enqueueSnackbar } = useLazySnackbar();
  const rudderTrack = useRudderStackTrack();

  const cancelBookingPreApprovalMutation = useCancelBookingPreApprovalMutation({
    onSuccess() {
      if (onSuccess) onSuccess();
      enqueueSnackbar('This inquiry is no longer pre-approved.', { variant: 'success' });
      closeModal();
    },
    onError(e) {
      console.error(e);
    },
  });

  const cancelPreApproval = () => {
    cancelBookingPreApprovalMutation.mutate({ id: booking.id });
    rudderTrack('booking_action_owner', {
      action: 'cancel-pre-approval',
      booking: booking.id,
      location: 'cancel-pre-approcal-modal',
    });
  };

  return (
    <Wrapper>
      <Heading>
        Are you sure you want to cancel <br /> this pre-approval?
      </Heading>

      <Description>
        Cancelling this pre-approval means that this renter’s inquiry will no longer be automatically approved. If they
        decide to book your boat, you will need to approve (or deny) their request at that time.
      </Description>

      <ButtonsWrapper>
        <Button
          disabled={cancelBookingPreApprovalMutation.isLoading}
          type="submit"
          text="cancel pre-approval"
          variant="danger"
          onClick={cancelPreApproval}
        />
        <Button
          disabled={cancelBookingPreApprovalMutation.isLoading}
          text="cancel"
          variant="owner"
          outline
          onClick={closeModal}
        />
      </ButtonsWrapper>
    </Wrapper>
  );
};

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 50px;

  ${mediaMSmMax} {
    padding-top: 30px;
    flex-flow: column;
  }

  button {
    ${mediaMSmMax} {
      width: 100% !important;
    }

    &:first-child {
      width: 75%;
    }
    &:last-child {
      width: 25%;
    }
  }
`;

const Wrapper = styled.div``;

const Heading = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 600;

  ${mediaMSmMax} {
    font-weight: 600;
    font-size: 20px;

    br {
      display: none;
    }
  }
`;

const Description = styled.div``;

export default CancelPreApprovalModal;
